module.exports = "//static.hsappstatic.net/marketplace-ui-common/static-1.8314/img/storefront-header-blobs.svg"